"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.runInFork = void 0;
const runInFork = (callback) => {
    let result;
    let error;
    new Promise((resolve) => {
        try {
            result = callback();
            resolve(result);
        }
        catch (err) {
            error = err;
        }
    });
    if (error) {
        throw error;
    }
    return result;
};
exports.runInFork = runInFork;
//# sourceMappingURL=runInFork.js.map